import React from "react";
import ResponsiveImg from "./ResponsiveImg";

export default function SplitSection({
  id,
  eyebrow,
  title,
  subtitle,
  body,
  bullets,
  outro,
  imageUrl,
  imageAlt,
  reverse = false,
  dark = false,
  label,
}) {
  const isDark = dark;
  return (
    <section
      id={id}
      data-testid={id ? `split-${id}` : "split-section"}
      className={`relative ${isDark ? "bg-[#0f2420]" : "bg-cream"}`}
    >
      <div className="container-vlx py-24 md:py-32">
        <div
          className={`grid md:grid-cols-12 gap-10 md:gap-20 items-center ${
            reverse ? "md:[&>*:first-child]:order-2" : ""
          }`}
        >
          <div className="md:col-span-5">
            <span
              className={`eyebrow ${isDark ? "eyebrow-light" : ""}`}
            >
              {eyebrow}
            </span>
            <div className="mt-4 rule-gold" />
            <h2
              className={`heading-lg mt-8 text-[34px] md:text-[52px] leading-[1.08] ${
                isDark ? "text-white" : "text-[#0f2420]"
              }`}
            >
              {title}
            </h2>
            {subtitle ? (
              <p
                className={`mt-6 font-cormorant italic text-[20px] md:text-[22px] ${
                  isDark ? "text-[#e2b880]" : "text-[#7a5b2f]"
                }`}
              >
                {subtitle}
              </p>
            ) : null}
            {body ? (
              <p
                className={`mt-8 text-[15px] leading-[1.95] font-nunito max-w-lg ${
                  isDark ? "text-white/75" : "text-neutral-700"
                }`}
              >
                {body}
              </p>
            ) : null}
            {bullets && bullets.length > 0 ? (
              <ul className="mt-10 space-y-4 max-w-lg">
                {bullets.map((b, i) => (
                  <li key={b} className="flex items-start gap-4">
                    <span
                      className={`mt-2 inline-block text-[10px] font-raleway tracking-[0.2em] ${
                        isDark ? "text-[#e2b880]" : "text-[#7a5b2f]"
                      }`}
                    >
                      0{i + 1}
                    </span>
                    <span
                      className={`font-nunito text-[15px] leading-[1.7] ${
                        isDark ? "text-white/85" : "text-neutral-800"
                      }`}
                    >
                      {b}
                    </span>
                  </li>
                ))}
              </ul>
            ) : null}
            {outro ? (
              <p
                className={`mt-8 text-[14px] leading-[1.85] font-nunito max-w-lg italic ${
                  isDark ? "text-white/55" : "text-neutral-600"
                }`}
              >
                {outro}
              </p>
            ) : null}
          </div>

          <div className="md:col-span-7 relative">
            <div
              className={`relative overflow-hidden ${
                isDark ? "bg-[#0a1a17]" : "bg-[#efe8d6]"
              }`}
            >
              <ResponsiveImg
                src={imageUrl}
                alt={imageAlt}
                sizes="(max-width: 768px) 100vw, 60vw"
                className="block w-full h-auto max-h-[640px] object-contain mx-auto transition-transform duration-[2200ms] ease-out hover:scale-[1.03]"
              />
              <div className="absolute top-4 left-4 flex items-center gap-3 text-[10px] tracking-[0.5em] uppercase font-raleway text-white/90 bg-black/30 backdrop-blur px-3 py-1.5">
                <span className="w-4 h-px bg-[#e2b880]" />
                VIEWLUX
              </div>
              {label ? (
                <div className="absolute bottom-4 right-4 bg-[#0f2420]/85 backdrop-blur text-[#e2b880] px-4 py-2.5 text-[10px] tracking-[0.35em] uppercase font-raleway">
                  {label}
                </div>
              ) : null}
            </div>
            <div
              className={`hidden md:block absolute -z-0 ${
                reverse ? "-left-6" : "-right-6"
              } -top-6 h-24 w-24 border-t border-r border-[#c99658]/50`}
            />
            <div
              className={`hidden md:block absolute -z-0 ${
                reverse ? "-right-6" : "-left-6"
              } -bottom-6 h-24 w-24 border-b border-l border-[#c99658]/50`}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
